import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot
import { ChakraProvider, ColorModeScript  } from '@chakra-ui/react';
import App from './App';
import theme from './theme'; // Optional: for custom themes
// In your main file (e.g., App.js or index.js)


// Use the createRoot API for React 18
const container = document.getElementById('root'); // Get the root element
const root = createRoot(container); // Create a root

// Render the App component to the root
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
